import React from "react";

export const RadioButton = ({
    key,
    id,
    name,
    number,
    label,
    componentName,
    answersOnQuestions,
    setAnswersOnQuestions
}) => {
    const changeHandler = (e) => {
        const target = e.target;

        localStorage.setItem(componentName, target.id)

        setAnswersOnQuestions((answersOnQuestionsOld) => {
            const answersOnQuestionsDraft = {...answersOnQuestionsOld}
            answersOnQuestionsDraft[componentName] = target.id

            return answersOnQuestionsDraft
        })
    };
    const isRadioChecked = answersOnQuestions[componentName] === id;

    return (
        <div className="choice__act" key={key}>
            <input id={id}
                   type={'radio'}
                   name={name}
                   checked={isRadioChecked}
                   onChange={changeHandler}
            />
            <label id={id}>
                {number ? (<span>{number}</span>) : (<div className={'choice__check'}/>)}
                {label}
            </label>
        </div>
    )

}